const [majorVersion] = window.OC?.config?.version?.split(".") ?? [];
const isLegacy = Number.parseInt(majorVersion ?? "32") < 32;
export {
  isLegacy as i
};
//# sourceMappingURL=legacy-DcjXBL_t.mjs.map
